import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { TranslocoModule } from "@ngneat/transloco";
import { ComponentsModule } from "../../../components/components.module";
import { DirectivesModule } from "../../../configuration/directives/directives.module";
import { AssignmentModalComponent } from "./assignment-modal.component";
import { AssignmentDescriptionComponent } from "../components/assignment-description/assignment-description.component";
import { AssigneePickerModalComponent } from "../modals/assignee-picker/assignee-picker.modal.component";
import { QuillViewComponent } from "ngx-quill";
import { AssigneePickerModalService } from "../modals/assignee-picker/assignee-picker.modal.service";
import { AssetPickerModalComponent } from "../../../modals/asset-picker/asset-picker.modal.component";
import { AssetPickerModalService } from "../../../modals/asset-picker/asset-picker.modal.service";
import { AssignmentAssigneesComponent } from "../components/assignment-assignees/assignment-assignees.component";
import { AssignmentAssetComponent } from "../components/assignment-asset/assignment-asset.component";
import { AssignmentSolutionComponent } from "../components/assignment-solution/assignment-solution.component";
import { SolutionDetailsModalComponent } from "./solution-details/solution-details.modal.component";
import { AssignmentSolutionDetailsModalService } from "./solution-details/solution-details.modal.service";
import { AttachmentsComponent } from "../../checklists/components/shared/attachments/attachments.component";
import { AssignmentService } from "../services/assignment.service";
import { AssignmentModalService } from "./assignment-modal.service";
import { QuillEditorComponent } from "ngx-quill";

@NgModule({
	declarations: [
		AssignmentModalComponent,
		AssignmentDescriptionComponent,
		AssigneePickerModalComponent,
		AssetPickerModalComponent,
		AssignmentAssigneesComponent,
		AssignmentAssetComponent,
		AssignmentSolutionComponent,
		SolutionDetailsModalComponent,
	],
	providers: [
		AssigneePickerModalService,
		AssetPickerModalService,
		AssignmentSolutionDetailsModalService,
		AssignmentService,
		AssignmentModalService,
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		IonicModule,
		TranslocoModule,
		ComponentsModule,
		DirectivesModule,
		QuillViewComponent,
		AttachmentsComponent,
		QuillEditorComponent,
	],
})
export class AssignmentModule {}
